
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getPaytype} from 'sr/utils/api/masterData/paytype/getPaytype'
export const fetchpaytype = createAsyncThunk(
  'getPaytype',
  async () => {
    const response = await getPaytype()
    return response?.data
  }
)


